// v-sticky.js
// Usage: v-sticky="{ position: 'top', offset: 20 }"

function getOffset(el) {
  const rect = el.getBoundingClientRect();
  return {
    top: rect.top + window.scrollY,
    left: rect.left + window.scrollX,
  };
}

function handleScroll(el, binding) {
  const { position = 'top', offset = 0 } = binding.value || {};
  const offsetPx = typeof offset === 'number' ? offset : parseInt(offset, 10) || 0;
  const elOffset = el.__stickyOriginalOffset;
  if (!elOffset) return;

  let shouldFix = false;
  if (position === 'top') {
    shouldFix = window.scrollY + offsetPx > elOffset.top;
  } else if (position === 'bottom') {
    shouldFix = window.scrollY + window.innerHeight - offsetPx < elOffset.top + el.offsetHeight;
  } else if (position === 'left') {
    shouldFix = window.scrollX + offsetPx > elOffset.left;
  } else if (position === 'right') {
    shouldFix = window.scrollX + window.innerWidth - offsetPx < elOffset.left + el.offsetWidth;
  }

  if (shouldFix) {
    el.style.position = 'fixed';
    el.style.zIndex = '1000';
    el.style.top = '';
    el.style.bottom = '';
    el.style.left = '';
    el.style.right = '';
    el.style[position] = offsetPx + 'px';
    // Optionally set width to avoid shrinking
    if (position === 'top' || position === 'bottom') {
      el.style.width = el.__stickyOriginalWidth;
    }
  } else {
    el.setAttribute('style', el.__stickyOriginalStyle || '');
  }
}

function updateSticky(el, binding) {
  // Save original offset and width
  el.__stickyOriginalOffset = getOffset(el);
  el.__stickyOriginalWidth = window.getComputedStyle(el).width;
  handleScroll(el, binding);
}

export default {
  mounted(el, binding) {
    el.__stickyOriginalStyle = el.getAttribute('style') || '';
    updateSticky(el, binding);
    el.__stickyScrollHandler = () => handleScroll(el, binding);
    el.__stickyResizeHandler = () => updateSticky(el, binding);
    window.addEventListener('scroll', el.__stickyScrollHandler);
    window.addEventListener('resize', el.__stickyResizeHandler);
  },
  updated(el, binding) {
    updateSticky(el, binding);
  },
  unmounted(el) {
    window.removeEventListener('scroll', el.__stickyScrollHandler);
    window.removeEventListener('resize', el.__stickyResizeHandler);
    el.setAttribute('style', el.__stickyOriginalStyle || '');
    delete el.__stickyOriginalStyle;
    delete el.__stickyOriginalOffset;
    delete el.__stickyOriginalWidth;
    delete el.__stickyScrollHandler;
    delete el.__stickyResizeHandler;
  },
}; 
